// removed by extract-text-webpack-plugin
module.exports = {"contributors":"lCzH_a_zk_4vhvhjwNe7c","contributors__list":"_2Len9LGxtUJ6nVK4VzO8nr","contributor":"_24UGgNoPpqYOYWy78Y7-7L","contributor__name":"_3P40Ju0MfFBTDmTFbL4-zM"};


//////////////////
// WEBPACK FOOTER
// ../components/Contributors/Contributors.module.css
// module id = 567
// module chunks = 0